<template>
  <div>
    <Header></Header>
    <div class="warp"></div>
    <div class="school-industry-nav">
      <Banner></Banner>
    </div>

    <div v-show="selectedTag || keywords || classification" class="school-industry-mbx">
      <div class="warp">
        <a-row :gutter="[0, 0]">
          <a-col :span="24">
            <div class="tag-title" v-if="searchType === 'default'">
              <news-tags
                :tags="readTags"
                @getTagNews="getTagNews"
                :classification="classification"
              >
                <span slot="title">行业的人都在看 &nbsp;&nbsp;&nbsp;&nbsp;</span>
              </news-tags>
            </div>
            <div v-else-if="searchType === 'selectedTag'" class="news-keywords">
              <span class="fontsize18"
                >当前标签：<em>{{ selectedTag }}</em>
                <a-icon
                  type="close-circle"
                  theme="filled"
                  class="tag-icon"
                  @click="clearSelectedTag"
                  :style="{ fontSize: '12px', color: '#323232', opacity: '0.2' }"
                />
              </span>
            </div>
            <div v-else-if="searchType === 'keywords'" class="news-keywords">
              <span class="fontsize18"
                >搜索结果：“<em>{{ keywords }}</em
                >”</span
              >
            </div>
          </a-col>
        </a-row>
      </div>
    </div>

    <div class="ab-school-industry">
      <div class="warp">
        <a-row :gutter="[0, 0]" type="flex">
          <a-col :xl="18" :lg="18" :md="18" :sm="24" :xs="24">
            <div class="block-left">
              <slot name="Picture-News" v-if="!selectedTag && !keywords"></slot>
              <news-list
                :classification="classification"
                :keywords="keywords"
                :selectedTag="selectedTag"
                :searchType="searchType"
              ></news-list>
            </div>
          </a-col>
          <a-col :xl="6" :lg="6" :md="6" :sm="24" :xs="24">
            <div class="block-right">
              <div class="block-right-ad">
                <AdvertisingBlock></AdvertisingBlock>
              </div>

              <a-card :loading="loading" :bordered="false">
                <div class="ad-school-search">
                  <a-input-search
                    allow-clear
                    placeholder="输入关键词"
                    size="large"
                    @search="onSearch"
                  >
                    <a-button slot="enterButton">
                      <i class="iconfont icon-sousuo"></i>
                    </a-button>
                  </a-input-search>
                </div>
              </a-card>
              <div class="hot-style">
                <hot-news :classification="classification"></hot-news>
                <hot-tags
                  @getHotTags="getHotTags"
                  @getTagNews="getTagNews"
                  :classification="classification"
                ></hot-tags>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "./Banner.vue";
import Header from "./Header.vue";
import HotTags from "./HotTags.vue";
import HotNews from "./HotNews.vue";
import NewsList from "./NewsList.vue";
import NewsTags from "./NewsTags.vue";
import AdvertisingBlock from "./AdvertisingBlock.vue";
import constant from "../constant.js";
// import reqwest from 'reqwest';

export default {
  props: ["classification"],
  components: {
    Banner,
    HotTags,
    HotNews,
    Header,
    NewsList,
    NewsTags,
    AdvertisingBlock,
  },
  data() {
    return {
      // timeFix: timeFix(),
      ...constant,
      avatar: "",
      user: {},
      projects: [],
      loading: false,
      keywords: null,
      selectedTag: "",
      searchType: null,
      data: [],
      readTags: [
        // "海关政策",
        // "港口动态",
        // "人民币汇率",
        // "海关政策",
        // "港口动态",
        // "人民币汇率",
      ],
    };
  },
  mounted() {
    console.log("parent mounted");
    if (this.$route.query.keywords !== undefined) {
      this.searchType = "keywords";
      this.keywords = this.$route.query.keywords.trim();
    }

    if (this.$route.query.tag) {
      this.searchType = "selectedTag";
      this.selectedTag = this.$route.query.tag;
    }

    if (this.$route.query.keywords === undefined && this.$route.query.tag === undefined) {
      console.log("1111111111111111111111111");
      this.searchType = "default";
    }
  },
  watch: {
    $route(newRoute) {
      console.log("newRoute", newRoute);
      // this.selectedTag = newRoute.query.tag ? newRoute.query.tag : ""; // 这里就是新的query
      if (newRoute.query.tag) {
        this.selectedTag = newRoute.query.tag;
        this.searchType = "selectedTag";
      }

      // this.keywords = newRoute.query.keywords ? newRoute.query.keywords.trim() : "";
      if (newRoute.query.keywords !== undefined) {
        this.keywords = newRoute.query.keywords.trim(); // 这里就是新的query
        this.searchType = "keywords";
      }

      if (newRoute.query.keywords === undefined && newRoute.query.tag === undefined) {
        console.log("1111111111111111111111111");
        this.searchType = "default";
        // if (this.selectedTag) {
        //   this.selectedTag = "";
        // }
        // this.keywords = "";
        // if(this.keywords){
        //   this.keywords = ''
        // }
        // this.selectedTag = newRoute.query
        // this.$router.push({
        //   path: this.classification
        //     ? "/school/" + this.classificationObj[this.classification]
        //     : "/school",
        // });
      }
    },
  },
  methods: {
    clearSelectedTag() {
      this.selectedTag = "";
      this.searchType = "default";
      this.$router.push({
        path: this.classification
          ? "/school/" + this.classificationObj[this.classification]
          : "/school",
      });
    },
    onSearch(value) {
      console.log("onSearch", value);
      let keywords = value.trim();
      // this.keywords = keywords;
      this.searchType = "keywords";
      this.$router.push({
        path: this.classification
          ? "/school/" + this.classificationObj[this.classification]
          : "/school",
        query: { keywords },
      });
    },
    getHotTags(tags) {
      this.readTags = tags;
    },
    getTagNews(tag) {
      console.log("--tag--", tag);
      this.searchType = "selectedTag";
      this.selectedTag = tag;
    },
  },
};
</script>

<style lang="sass" scoped>
::v-deep .ant-card-body {
    padding: 0px;
}
.ad-school-search{
  ::v-deep .ant-input-search-button{
    width: 60px;
    height: 60px;
    background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
    border-radius: 0px 4px 4px 0px;
    i{
      font-size:38px;
      margin-left: -4px;
      margin-top:2px;
      color:#fff;
    }
    &:hover{
      background:linear-gradient(230deg, #217AF9 0%, #217AF9 100%)
    }
  }
  ::v-deep .ant-input{
    height:60px;
    font-size:18px;
    font-family: 'Alibaba-PuHuiTi-R';
  }
  padding-bottom:30px ;padding-top:10px;
}

  .tag-icon{
    cursor: pointer;
    &:hover{
      transform: scale(1.2);
    }
  }

::v-deep .news-tags a:hover{
    text-decoration: underline;
}
.school-industry-mbx{
    background: #F6F6F8;
    height:50px;
    .news-keywords{
      // height: 50px;
      background: #F6F6F8;
      > span {
        padding-left: 33px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #333646;
        line-height: 50px;
        > em{
          color: #2B68FF;
        }
      }
    }
    .tag-title{
      padding-left: 0px;
      height: 50px;
      > span {
        line-height: 50px;
      }
    }
}
.school-industry-nav{
    border-bottom: 1px #D8D8D8 solid;
}
.ab-school-industry{
  min-height: 1500px;
  .block-left{
    height: 100%;
    padding: 60px 81px 60px 0px;
  }
  .block-right{
    padding: 60px 0px 24px 0px;
    height: 100%;
    .block-right-ad{
      padding-bottom: 24px;
    }
  }
}
  .hot-style{
    position: sticky;
    top: 65px;
    z-index: 1;
  }
</style>
